import { render, staticRenderFns } from "./shouruQS.vue?vue&type=template&id=24bb5ecd&scoped=true&"
import script from "./shouruQS.vue?vue&type=script&lang=js&"
export * from "./shouruQS.vue?vue&type=script&lang=js&"
import style0 from "./shouruQS.vue?vue&type=style&index=0&id=24bb5ecd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb5ecd",
  null
  
)

export default component.exports